import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as AppActions from "../../actions";
import Header from "../../components/Header";
import { confirmAlert } from "react-confirm-alert";
import ApproveReject from "../../components/ApproveReject";
import { Icon, Loader } from "semantic-ui-react";
import ReactModal from "react-modal";
import InfiniteScroll from "react-infinite-scroller";
import SentListItem from "../../components/SentListItem";
import _ from "lodash";
import { Document, Page } from "react-pdf";
const uuidv4 = require("uuid/v1");

const customStylesRename = {
  content: {
    top: "50%",
    width: "85%",
    maxWidth: "400px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "0px;",
    borderRadius: "5px",
    border: "0px",
    height: "370px",
    backgroundColor: "#fff",
    transform: "translate(-50%, -50%)"
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  }
};

const customStylesPreview = {
  content: {
    width: "100%",
    height: "100%",
    top: "0px",
    padding: "0px",
    borderRadius: "0px",
    left: "0px",
    backgroundColor: "#e6e6e6",
    border: "0px",
    overflowX: "hidden"
  }
};

class ApprovalsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lastRefresh: Date(Date.now()).toString(),
      sentItems: [],
      current_page: 1,
      modalVisible: false,
      status: "",
      numPages: 1,
      approveRejectModalVisible: false,
      hasMore: true,
      busyOpening: false
    };
    this.loading = false;
    this.tablet = window.innerWidth - 40 < 650 ? false : true;
    this.refreshScreen = this.refreshScreen.bind(this);
  }

  handleBack() {
    return true;
  }

  refreshScreen() {
    if (this.props.isConnected) {
      this.setState({
        lastRefresh: Date(Date.now()).toString(),
        current_page: 1
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const different =
      this.state.lastRefresh !== nextState.lastRefresh ||
      this.props.postingStatus !== nextProps.postingStatus ||
      this.state.status !== nextState.status ||
      this.state.approveRejectModalVisible !==
        nextState.approveRejectModalVisible ||
      this.state.busyOpening !== nextState.busyOpening ||
      this.props.report !== nextProps.report ||
      this.state.modalVisible !== nextState.modalVisible ||
      this.props.sentItems !== nextProps.sentItems ||
      this.props.isConnected !== nextProps.isConnected ||
      this.state.hasMore !== nextState.hasMore ||
      this.state.sentItems !== nextState.sentItems ||
      this.props.refresh !== nextProps.refresh ||
      this.props.filter !== nextProps.filter;
    if (this.state.lastRefresh !== nextState.lastRefresh) {
      const { actions } = this.props;

      actions.getApprovals(1);
    }

    if (different && this.props.sentItems !== nextProps.sentItems) {
      if (nextProps.sentItems.length > 0) {
        if (this.state.current_page === 1) {
          this.setState({
            current_page: this.state.current_page + 1,
            hasMore: nextProps.sentItems.length < 20 ? false : true,
            sentItems: nextProps.sentItems
          });
        } else {
          this.setState({
            current_page: this.state.current_page + 1,
            hasMore: nextProps.sentItems.length < 20 ? false : true,
            sentItems: [...this.state.sentItems, ...nextProps.sentItems]
          });
        }
      } else {
        this.setState({ hasMore: false });
      }
    } else {
      if (nextProps.sentItems.length === 0 && !this.props.isConnected) {
        this.props.actions.getApprovals(1);
      }
    }

    return different;
  }

  showConfirmStatus(status) {
    const options = {
      title: "Confirmation",
      message: "This form has been " + status,
      buttons: [
        {
          label: "OK",
          onClick: () => {
            this.setModalVisible(false);
            this.refreshScreen();
          }
        },
        {
          label: "Cancel",
          onClick: () => {}
        }
      ]
    };

    confirmAlert(options);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.postingStatus === "doneContainer") {
      this.props.actions.setPostingStatus("");
      this.setState({ approveRejectModalVisible: false });
      this.showConfirmStatus(this.state.status === 2 ? "rejected" : "approved");
    } else {
      if (this.props.report !== newProps.report && !this.state.modalVisible) {
      } else {
        if (
          this.props.isLoading !== newProps.isLoading &&
          !newProps.isLoading &&
          this.state.modalVisible &&
          !this.state.busyOpening
        ) {
          let form_id = this.props.report_form_id;
          let currentForm = _.filter(this.props.forms, function(data) {
            return Number(data.form_id) === Number(form_id);
          });

          let icon_path = "";
          let approval_enabled = false;
          if (currentForm.length > 0) {
            icon_path = currentForm[0].icon_path;
            approval_enabled = currentForm[0].approval_enabled;
          }
          this.setState({ busyOpening: true });
          this.handleClick(
            form_id,
            this.props.report_title,
            icon_path,
            this.props.report_version,
            approval_enabled
          );
        }
      }
    }
  }

  componentWillMount() {
    const { actions, sessionId, deviceId, sentItems, refresh } = this.props;

    actions.getApprovals(1);
  }

  handleReport(
    result_id,
    form_title,
    form_version,
    date_added,
    form_id,
    icon_path
  ) {
    this.props.actions.openingSentItem(false);
    this.props.actions.resetSentItems();
    this.setModalVisible(true);
    this.props.actions.getFormReport(
      result_id,
      form_title,
      form_version,
      date_added,
      form_id,
      icon_path
    );
  }

  handleClick(form_id, form_title, icon_path, form_version, approval_enabled) {
    var form = _.filter(this.props.actionQueue, {
      draftName: "",
      test: this.props.test
    });

    this.props.actions.updateFormExists(true);
    this.props.actions.updateFormTitle(
      form_title,
      form_version,
      icon_path,
      form_id,
      "",
      approval_enabled
    );
    let recovered = false;

    this.props.actions.setWorkingDraft(form[0].draft, "");

    let uuid = uuidv4();
    this.props.history.push(
      `/form/${form_id}/${"!" +
        uuid}/true/${recovered}/${form_title}/${form_version}/${
        this.props.result_id
      }/0`
    );

    setTimeout(() => {
      this.props.actions.openingSentItem(false);
      this.setModalVisible(false);
      this.setState({ busyOpening: false });
    }, 0);
  }

  setModalVisible(visible) {
    this.setState({ modalVisible: visible });
  }

  handleSearch(from_date, to_date, user_id, form_id) {
    if (this.props.isConnected) {
      this.props.actions.resetSentItems();
      this.props.actions.getApprovals(1, from_date, to_date, user_id, form_id);
      this.setState({
        fromDate: from_date,
        toDate: to_date,
        user_id: user_id,
        form_id: form_id,
        current_page: 1,
        hasMore: true,
        sentItems: []
      });
    }
  }

  handleFilter(value) {
    this.props.actions.filterJobs(value);
  }

  getForms() {
    var sentItemsArray = [];

    let width = this.width < 450 ? 135 : 151;

    this.state.sentItems.forEach((form, index) => {
      sentItemsArray.push(
        <div
          className="listcontainer"
          style={{
            flex: 1,
            width: "600px",
            borderRadius: 4,
            marginBottom: 30,
            backgroundColor: "white",
            borderWidth: 2,
            flexDirection: "row"
          }}
          key={"v" + index}
        >
          <SentListItem
            forms={this.props.forms}
            storeColour={this.props.storeColour}
            width={width}
            container="Jobs"
            onClick={this.handleReport.bind(this)}
            {...form}
            key={index}
          />
        </div>
      );
    });

    if (
      (this.state.hasMore || this.state.current_page === 1) &&
      this.props.total !== -1 &&
      this.props.total !== 0
    ) {
      sentItemsArray.push(
        <div className="formSectionContainer">
          <form className="ui form">
            <Loader active size="large" inline="centered">
              Loading
            </Loader>
          </form>
        </div>
      );
    }

    return <div style={{ textAlign: "left" }}>{sentItemsArray}</div>;
  }

  getListOfSentItems = () => {
    if (this.loading) {
      return;
    }
    this.loading = true;

    this.props.actions.getApprovals(
      this.state.current_page,
      this.state.fromDate,
      this.state.toDate,
      this.state.user_id,
      this.state.form_id
    );
  };

  isCloseToBottom({ layoutMeasurement, contentOffset, contentSize }) {
    let y =
      layoutMeasurement.height + contentOffset.y >= contentSize.height - 800;
    return y;
  }

  handleCopySent(result_id, title, form_id, form_version, date_added) {
    this.props.actions.openingSentItem(true);
    this.props.actions.resetCopy();
    this.props.actions.readSentItemData(
      result_id,
      title,
      form_id,
      form_version,
      date_added
    );
  }

  handleApproveRejectDraft(note) {
    const { result_id } = this.props;
    this.props.actions.postStatusHistory(
      result_id,
      this.state.status,
      note,
      "Container"
    );
  }

  handleClosePreview() {
    this.setModalVisible(false);
    this.props.actions.updatePreview_go("");
    this.setState({ numPages: 1 });
    this.props.actions.updateReport("", "", "", -1, "", "");
  }

  renderApproveRejectModal() {
    if (this.state.approveRejectModalVisible) {
      const { report_title } = this.props;

      return (
        <ReactModal
          isOpen={this.state.approveRejectModalVisible}
          style={customStylesRename}
          contentLabel="Example Modal"
          onRequestClose={() => {
            //alert('Modal has been closed.');
          }}
        >
          <div
            style={{
              paddingTop: 40,
              backgroundColor: "white",
              paddingLeft: 20,
              paddingRight: 20,
              borderRadius: 6,
              width: "100%",
              height: "100%"
            }}
          >
            <Icon
              type="MaterialIcons"
              onClick={() =>
                this.setState({ approveRejectModalVisible: false })
              }
              style={{
                position: "absolute",
                right: "20px",
                top: "20px",
                color: "#e6e6e6",
                cursor: "pointer"
              }}
              size="large"
              name="close"
            />
            <ApproveReject
              postingStatus={this.props.postingStatus}
              storeColour={this.props.storeColour}
              form_title={report_title}
              onApproveReject={this.handleApproveRejectDraft.bind(this)}
            />
          </div>
        </ReactModal>
      );
    } else {
      return null;
    }
  }

  handleApprove() {
    this.setState({ approveRejectModalVisible: true, status: 3 });
  }

  handleReject() {
    this.setState({ approveRejectModalVisible: true, status: 2 });
  }
  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages: numPages });
  };

  showLoading(message) {
    return (
      <div>
        <form className="ui form">
          <br />
          <br />
          <br />
          <br />
          <br />
          <Loader active size="large" inline="centered">
            {message}
          </Loader>
        </form>
      </div>
    );
  }

  renderModal() {
    const { report_title } = this.props;

    return (
      <ReactModal
        isOpen={this.state.modalVisible}
        style={customStylesPreview}
        contentLabel="Example Modal"
        onRequestClose={() => {
          //alert('Modal has been closed.');
        }}
      >
        <Header
          onCopySent={this.handleCopySent.bind(this)}
          storeColour={this.props.storeColour}
          dateAdded={this.props.report_date_added}
          result_id={this.props.result_id}
          formId={this.props.report_form_id}
          onCloseModal={this.handleClosePreview.bind(this)}
          modal={true}
          preview={true}
          onBack={this.handleBack.bind(this)}
          backLink={"/sent"}
          formTitle={report_title}
          formVersion={this.props.report_version}
        ></Header>
        <Document
          loading={this.showLoading("Loading")}
          noData={this.showLoading("Loading")}
          onLoadSuccess={this.onDocumentLoadSuccess}
          file={this.props.report}
        >
          {_.range(1, this.state.numPages + 1, 1).map(page => (
            <Page pageNumber={page} width={window.outerWidth} />
          ))}
        </Document>
        <div style={{ position: "fixed", zIndex: 100, bottom: 10, right: 20 }}>
          <span>
            <button
              className="ui button sort"
              onClick={this.handleReject.bind(this)}
              role="button"
            >
              Reject
            </button>
          </span>
          <span>
            <button
              className="ui button sort"
              onClick={this.handleApprove.bind(this)}
              role="button"
            >
              Approve
            </button>
          </span>
        </div>
      </ReactModal>
    );
  }

  render() {
    const { actions } = this.props;
    setTimeout(() => {
      this.loading = false;
    }, 500);

    if (this.props.isConnected) {
      if (this.props.report !== "" && this.state.modalVisible) {
        return (
          <div>
            {this.renderModal()}
            {this.renderApproveRejectModal()}
            <Header
              setSidebarVisibility={actions.setSidebarVisibility}
              onSearch={this.handleSearch.bind(this)}
              storeColour={this.props.storeColour}
              filter={this.props.filter}
              onFilter={this.handleFilter.bind(this)}
              onRefresh={this.refreshScreen}
              navigation={this.props.navigation}
              formTitle={"Approvals"}
            ></Header>
          </div>
        );
      } else {
        return (
          <div>
            {this.renderModal()}
            {this.renderApproveRejectModal()}
            <Header
              setSidebarVisibility={actions.setSidebarVisibility}
              onSearch={this.handleSearch.bind(this)}
              storeColour={this.props.storeColour}
              filter={this.props.filter}
              onFilter={this.handleFilter.bind(this)}
              onRefresh={this.refreshScreen}
              navigation={this.props.navigation}
              formTitle={"Approvals"}
            ></Header>

            <div
              className="formsBackground"
              style={{
                height: window.innerHeight,
                paddingBottom: "142px",
                overflowY: "scroll",
                "-webkit-overflow-scrolling": "touch"
              }}
            >
              <InfiniteScroll
                useWindow={false}
                initialLoad={false}
                threshold={0}
                pageStart={0}
                loadMore={this.getListOfSentItems.bind(this)}
                hasMore={true}
              >
                <div
                  style={{ textAlign: "center" }}
                  className="formSectionContainerX"
                >
                  <form
                    className="ui formList"
                    style={{ display: "inline-block", padding: "30px" }}
                  >
                    {this.getForms()}
                  </form>
                </div>
              </InfiniteScroll>
            </div>
          </div>
        );
      }
    } else {
      return (
        <div>
          <Header
            setSidebarVisibility={actions.setSidebarVisibility}
            onSearch={this.handleSearch.bind(this)}
            storeColour={this.props.storeColour}
            filter={this.props.filter}
            onFilter={this.handleFilter.bind(this)}
            onRefresh={this.refreshScreen}
            navigation={this.props.navigation}
            formTitle={"Approvals"}
          ></Header>
          <div
            style={{
              flex: 1,
              alignContent: "center",
              alignItems: "center",
              backgroundColor: "#e6e6e6"
            }}
          >
            <div style={{ marginTop: 30, fontSize: 14 }}>
              Offline: Connect online to see your approvals
            </div>
          </div>
        </div>
      );
    }
  }
}

ApprovalsContainer.propTypes = {
  sidebarVisibility: PropTypes.bool.isRequired,
  sessionId: PropTypes.string.isRequired,
  jobs: PropTypes.array.isRequired,
  filter: PropTypes.string.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  sidebarVisibility: state.informedWebApp.sidebarVisibility,
  sessionId: state.informedWebApp.sessionId,
  deviceId: state.informedWebApp.deviceId,
  isLoading: state.informedWebApp.isLoading,
  isConnected: state.informedWebApp.isConnected,
  storeColour: state.informedWebApp.storeColour,
  forms: state.forms.data,
  postingStatus: state.form.postingStatus,
  sentItems: state.sentItems.data,
  report: state.sentItems.report,
  report_title: state.sentItems.report_title,
  report_version: state.sentItems.report_version,
  result_id: state.sentItems.result_id,
  report_date_added: state.sentItems.report_date_added,
  report_form_id: state.sentItems.report_form_id,
  total: state.sentItems.total,
  test:
    state.informedWebApp.api === "https://www.in-formed.co.uk/api.php"
      ? false
      : true,
  actionQueue: state.informedWebApp.actionQueue
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApprovalsContainer);



// WEBPACK FOOTER //
// ./src/containers/ApprovalsContainer/index.js